export const cleanParams = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value != null)
  );

export const splitFilesFolders = (data = []) => {
  const files = [];
  const folders = [];

  data.forEach((item) => {
    if (item?.item_type === "file") files.push(item);
    else folders.push(item);
  });

  return { files, folders, all: data };
};